import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Anchor, Text } from '@zillow/constellation';

import { RMWContext } from 'app/shared/providers/RMWContext';

import './style.scss';

const propTypes = {
    actionText: PropTypes.string.isRequired,
    noMargin: PropTypes.bool,
    isTextCenter: PropTypes.bool,
};

const defaultProps = {
    noMargin: false,
    isTextCenter: false,
};

function ListingActivationTerms({
    actionText, noMargin, isTextCenter,
}) {
    const { paths } = useContext(RMWContext);

    return (
        <div
            className={cx('ListingActivationTerms', {
                'ListingActivationTerms-no-margin': noMargin,
                'ListingActivationTerms-text-center': isTextCenter,
            })}
        >
            <Text fontType="legal">
                {actionText}
                , you agree to comply with our&nbsp;
                <Anchor href={paths.corpTermsURL} target="_blank">Terms of Use</Anchor>
                ,&nbsp;
                <Anchor href={paths.rentalTermsURL} target="_blank">Rental User Terms</Anchor>
                , and&nbsp;
                <Anchor href={paths.pledgeURL} target="_blank">Respectful Renting Pledge</Anchor>
                .
            </Text>
        </div>
    );
}

ListingActivationTerms.propTypes = propTypes;
ListingActivationTerms.defaultProps = defaultProps;

export default ListingActivationTerms;
